import propTypes from 'prop-types';

const Spacer = ({ x, y, ...rest }) => {
    const getSize = (value) => {
        if (!value) return undefined;
        return value.match(/^(xxs|xs|s|m|l|xl|xxl)$/) ? `var(--space-${value})` : value;
    };

    return (
        <div
            style={{
                width: getSize(x),
                height: getSize(y),
            }}
            {...rest}
        />
    );
};

Spacer.propTypes = {
    x: propTypes.oneOfType([propTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']), propTypes.string]),
    y: propTypes.oneOfType([propTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']), propTypes.string]),
};

export default Spacer;
